import React, { useEffect, useRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./styles";
import {
	WorkformViewer,
	AssignedStudentRatings,
	BottomButtons,
	RatingRequest,
	RatingRespond,
} from "@manakin/app-core";
import { Header } from "./parts";
import classNames from "classnames";
import { useLocation, useParams, withRouter } from "react-router-dom";
import { getAppUser } from "@manakin/authentication/selectors";
import { compose } from "redux";
import { connect } from "react-redux";
import { getProgram } from "@manakin/app-core/ProgramsDropdown/selectors";
import { getBoxId } from "@manakin/app-core/Boxes/selectors";
import { Typography } from "@material-ui/core";
import { useTranslation } from 'react-i18next';

const FinalRating = (props) => {
	const {
		classes,
		workforms,
		options,
		onFinish,
		finalRatingData = {},
		prefix,
		onReset,
		preview = false,
		onClose,
		appUser,
	} = props;
	const location = useLocation();
	const currentScrollPosition = useRef(null);
	const params = useParams();
	const studentId = params.studentId || appUser.id;
	const { t } = useTranslation();

	//functions
	useEffect(() => {
		window.addEventListener("scroll", listenToScroll);
		return () => window.removeEventListener("scroll", listenToScroll);
	}, []);

	const listenToScroll = () => {
		currentScrollPosition.current =
			window.pageYOffset || document.documentElement.scrollTop;
	};

	const isTrainer =
		appUser &&
		appUser.roles &&
		appUser.roles.find((role) => role.trainer === true) !== undefined;

	return (
		<div className={classes.root}>
			<Header
				data={{
					...finalRatingData,
				}}
				prefix={prefix}
			/>
			<div className={classes.normalMargin}>
				<div className={classNames(classes.wrapper)}>
					<Typography variant="h4">
						{t("app.elements.final-rating.title")}
					</Typography>
					<AssignedStudentRatings studentId={studentId} />
				</div>
			</div>
			{workforms &&
				workforms.map((item) => (
					<div key={item.id} className={classes.normalMargin}>
						<div className={classNames(classes.largeWrapper)}>
							<WorkformViewer
								type={item.type}
								item={item}
								onFinish={onFinish}
								options={options}
								customLink={{
									state: {
										url: location.pathname,
										idx: currentScrollPosition.current,
									},
								}}
							/>
						</div>
					</div>
				))}

			{!isTrainer && (
				<div className={classes.normalMargin}>
					<div className={classNames(classes.largeWrapper)}>
						<RatingRequest isFinalRating={true} appUser={appUser} />
					</div>
				</div>
			)}

			{isTrainer && (
				<div className={classes.normalMargin}>
					<div className={classNames(classes.largeWrapper)}>
						<RatingRespond
							isFinalRating={true}
							studentId={params.studentId}
						/>
					</div>
				</div>
			)}

			{!preview && <BottomButtons onClose={onClose} onReset={onReset} />}
		</div>
	);
};

export default compose(
	withStyles(styles, { name: "AppFinalRating" }),
	withRouter,
	connect((state) => ({
		config: state.config,
		program: getProgram(state),
		box: getBoxId(state),
		appUser: getAppUser(state),
	}))
)(FinalRating);
